module.exports = __webpack_public_path__ + "img/product-details-1.3518b222.jpg";